import React from "react"
import types from "prop-types"
import ActivityCompletionIndicator from "./ActivityCompletionIndicator"

const ConversationsClosedDataElement = ({ value, rowData }) => (
  <ActivityCompletionIndicator total={value} open={rowData.openConversationsCount} label="closed" />
)

ConversationsClosedDataElement.propTypes = {
  value: types.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  rowData: types.object.isRequired,
}

export default ConversationsClosedDataElement
